
import Vue from "vue";
const defaultImage = require('@/assets/photouploadblue.png');
import CoownersList, { OwnershipType } from "@/components/common/CoownersList.vue";

export default Vue.extend({
    name: "DogRegistrationIndividualRequest",
    components: { 
      CoownersList     
    },
    props: {
      registration: { type: Object },
    },
    data: function () {
      return {
          defaultImage,
      };
    },
    computed: {
      dogOwnershipType: function() {
        return OwnershipType.Dog;
      },
  }
  });
  